import { generatePath } from "react-router-dom";
import { ACCOUNT_TAGS, ACCOUNT_TAG_BY_ID } from "../apiEndPoints";
import { api, convertKeysToCamelCase, convertKeysToSnakeCase } from "./api";

export const accountTags = api.injectEndpoints({
  endpoints: (builder) => ({
    createAccountTag: builder.mutation({
      query: ({ accountId, ...rest }) => ({
        url: generatePath(ACCOUNT_TAGS, { accountId }),
        method: "POST",
        body: convertKeysToSnakeCase(rest),
      }),
      invalidatesTags: ["AccountTags"],
    }),

    getAccountTags: builder.query({
      query: ({
        accountId,
        offset = 0,
        limit = 100,
        includeTotalCount = true,
        search,
      }) => {
        const baseUrl = generatePath(ACCOUNT_TAGS, { accountId });
        const queryParams = new URLSearchParams({
          offset,
          limit,
          include_total_count: includeTotalCount,
        });
        if (search) {
          queryParams.append("search", search);
        }
        return {
          url: `${baseUrl}?${queryParams.toString()}`,
          method: "GET",
        };
      },
      transformResponse: (response) => convertKeysToCamelCase(response),
      providesTags: (result, error, { accountId }) => [
        { type: "AccountTags", id: accountId },
      ],
    }),

    getAccountTag: builder.query({
      query: ({ accountId, accountTagId }) => ({
        url: generatePath(ACCOUNT_TAG_BY_ID, { accountId, accountTagId }),
        method: "GET",
      }),
      transformResponse: (response) => convertKeysToCamelCase(response),
      providesTags: (result, error, { accountId }) => [
        { type: "AccountTags", id: accountId },
      ],
    }),

    updateAccountTag: builder.mutation({
      query: ({ accountId, accountTagId, ...rest }) => ({
        url: generatePath(ACCOUNT_TAG_BY_ID, { accountId, accountTagId }),
        method: "PATCH",
        body: convertKeysToSnakeCase(rest),
      }),
      invalidatesTags: ["AccountTags"],
    }),

    deleteAccountTag: builder.mutation({
      query: ({ accountId, accountTagId }) => ({
        url: generatePath(ACCOUNT_TAG_BY_ID, { accountId, accountTagId }),
        method: "DELETE",
      }),
      invalidatesTags: ["AccountTags"],
    }),
  }),
});

export const {
  useCreateAccountTagMutation,
  useGetAccountTagsQuery,
  useGetAccountTagQuery,
  useUpdateAccountTagMutation,
  useDeleteAccountTagMutation,
} = accountTags;
